import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router, { setupRouterGuards } from './router'
import App from './App.vue'
import './assets/main.css'

const app = createApp(App)
const pinia = createPinia()

// 必须在 app.use(router) 之前设置路由守卫
// 否则初始导航不会被守卫拦截
setupRouterGuards(pinia)

app.use(pinia)
app.use(router)

app.mount('#app')
